var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1421,
    height: 841,
    viewBox: "0 0 1421 841",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1185.43 4.91942C1214.29 -7.82552 1247.59 9.0075 1254.44 39.7997L1419.16 780.268C1426.11 811.496 1402.34 841.125 1370.35 841.125L45.1961 841.125C17.5819 841.125 -4.80389 818.739 -4.8039 791.125L-4.8039 563.201C-4.80393 543.399 6.88156 525.463 24.9948 517.463L1185.43 4.91942Z",
    fill: "#F5F9FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon3);
export default __webpack_public_path__ + "static/media/Polygon-3.58fd3cbb1f553a958a499530fc5b3a39.svg";
export { ForwardRef as ReactComponent };